import { defineComponent as A, openBlock as o, createElementBlock as e, mergeProps as Z, unref as n, renderSlot as i, createElementVNode as l, createCommentVNode as p } from "vue";
import { useScalarIcon as u } from "../hooks/useScalarIcon.js";
const g = { key: 0 }, f = { key: 1 }, k = { key: 2 }, h = { key: 3 }, w = { key: 4 }, y = { key: 5 }, M = {
  name: "ScalarIconRadioButton"
}, b = /* @__PURE__ */ A({
  ...M,
  props: {
    label: {},
    weight: {}
  },
  setup(m) {
    const r = m, { bind: s, weight: a } = u(r);
    return (d, t) => (o(), e("svg", Z({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, n(s)), [
      i(d.$slots, "default"),
      n(a) === "bold" ? (o(), e("g", g, t[0] || (t[0] = [
        l("path", { d: "M128,20A108,108,0,1,0,236,128,108.12,108.12,0,0,0,128,20Zm0,192a84,84,0,1,1,84-84A84.09,84.09,0,0,1,128,212Zm0-140a56,56,0,1,0,56,56A56.06,56.06,0,0,0,128,72Zm0,88a32,32,0,1,1,32-32A32,32,0,0,1,128,160Z" }, null, -1)
      ]))) : n(a) === "duotone" ? (o(), e("g", f, t[1] || (t[1] = [
        l("path", {
          d: "M176,128a48,48,0,1,1-48-48A48,48,0,0,1,176,128Z",
          opacity: "0.2"
        }, null, -1),
        l("path", { d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm0-144a56,56,0,1,0,56,56A56.06,56.06,0,0,0,128,72Zm0,96a40,40,0,1,1,40-40A40,40,0,0,1,128,168Z" }, null, -1)
      ]))) : n(a) === "fill" ? (o(), e("g", k, t[2] || (t[2] = [
        l("path", { d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm56-88a56,56,0,1,1-56-56A56.06,56.06,0,0,1,184,128Z" }, null, -1)
      ]))) : n(a) === "light" ? (o(), e("g", h, t[3] || (t[3] = [
        l("path", { d: "M128,26A102,102,0,1,0,230,128,102.12,102.12,0,0,0,128,26Zm0,192a90,90,0,1,1,90-90A90.1,90.1,0,0,1,128,218Zm0-144a54,54,0,1,0,54,54A54.06,54.06,0,0,0,128,74Zm0,96a42,42,0,1,1,42-42A42,42,0,0,1,128,170Z" }, null, -1)
      ]))) : n(a) === "regular" ? (o(), e("g", w, t[4] || (t[4] = [
        l("path", { d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm0-144a56,56,0,1,0,56,56A56.06,56.06,0,0,0,128,72Zm0,96a40,40,0,1,1,40-40A40,40,0,0,1,128,168Z" }, null, -1)
      ]))) : n(a) === "thin" ? (o(), e("g", y, t[5] || (t[5] = [
        l("path", { d: "M128,28A100,100,0,1,0,228,128,100.11,100.11,0,0,0,128,28Zm0,192a92,92,0,1,1,92-92A92.1,92.1,0,0,1,128,220Zm0-144a52,52,0,1,0,52,52A52.06,52.06,0,0,0,128,76Zm0,96a44,44,0,1,1,44-44A44.05,44.05,0,0,1,128,172Z" }, null, -1)
      ]))) : p("", !0)
    ], 16));
  }
});
export {
  b as default
};
